import styled from 'styled-components';

import { spacingInRems } from '../themeUtils';
import { media } from '../../theme/styledMedia';

export default styled.div`
  && {
    .cardContent {
      position: relative;
      padding: 0 0 ${spacingInRems(2)} 0;
      .topContainer {
        padding: ${spacingInRems(2)};
        padding-bottom: 0;
        & > .title {
          width: 90%;
        }
      }
      .backButton {
        position: absolute;
        right: 0;
        top: 0;
        margin: ${spacingInRems()};
      }

      .noDataFound {
        text-align: center;
        padding: ${spacingInRems(2)} ${spacingInRems(2)} ${spacingInRems()};
      }
    }
    ${media.xs`
      .cardContent {
          .topContainer {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            padding-top: ${spacingInRems()};
            & > .title {
              width: auto;
              margin-top: ${spacingInRems(2)};
            }
            .backButton {
              transform: translateY(-50%);
              margin-right: 0;
            }
          }
        }
    `}
  }
`;
